import { SocketCuePayload } from "hooks/use-cues";

import styles from "./index.module.css";

type CallCuesProps = {
  toggleIsOpen: (itemId: string) => void;
  isOpen: boolean;
  triggered: Array<SocketCuePayload>;
};

export const CallCues = ({ toggleIsOpen, isOpen, triggered }: CallCuesProps) => {
  const callCues = triggered.filter((tr) => !["speed", "fillerword"].includes(tr.type));
  const fillerwordCues = triggered.filter((tr) => tr.type === "fillerword");
  const speedCues = triggered.filter((tr) => tr.type === "speed");

  const callCuesCounts = callCues.reduce<Record<string, number>>((acc, item) => {
    const name = item.metadata.name;
    if (name) {
      acc[name] = (acc[name] || 0) + 1;
    }
    return acc;
  }, {});

  const speedCuesCount = speedCues.reduce<Record<string, number>>((acc, item) => {
    const name = item.metadata.name;
    if (name) {
      acc[name] = (acc[name] || 0) + 1;
    }
    return acc;
  }, {});

  const fillerwordCuesCounts = fillerwordCues.reduce<
    Record<string, { count: number; occurrence: number }>
  >((acc, item) => {
    const word = item.metadata?.word;
    const count = item.metadata?.count ?? 0;

    if (word) {
      if (!acc[word]) {
        acc[word] = { count: 0, occurrence: 0 };
      }

      acc[word].count += count;
      acc[word].occurrence += 1;
    }

    return acc;
  }, {});

  const disabled = triggered.length === 0;

  return (
    <div className={styles.accordion}>
      <div className={styles.accItem} data-open={isOpen}>
        <button
          type="button"
          className={styles.accSummary}
          aria-expanded={isOpen}
          aria-controls="acc-panel-cues"
          data-open={isOpen ? "true" : "false"}
          onClick={() => toggleIsOpen("cues")}
          aria-disabled={disabled}
          disabled={disabled}
        >
          {`Cues Received (${triggered.length})`}
          <span
            className={styles.accChevron}
            data-open={isOpen ? "true" : "false"}
            aria-hidden="true"
            aria-disabled={disabled}
          />
        </button>

        <div id="acc-panel-cues" role="region" className={styles.accContent} hidden={!isOpen}>
          <ul>
            {Object.keys(callCuesCounts).map((cue) => {
              return (
                <li key={`call-cue-${cue}`}>
                  <div className={styles.cueContainer}>
                    <div className={styles.cueName}>{cue}</div>
                    <div className={styles.cueCount}>{callCuesCounts[cue]}</div>
                  </div>
                </li>
              );
            })}
            {Object.keys(fillerwordCuesCounts).map((cue) => {
              return (
                <li key={`repeated-cue-${cue}`}>
                  <div className={styles.cueContainer}>
                    <div className={styles.cueName}>
                      {`Repetitive Word: '${cue}'`}
                      <div>{fillerwordCuesCounts[cue]["count"]} total mentions</div>
                    </div>
                    <div className={styles.cueCount}>{fillerwordCuesCounts[cue]["occurrence"]}</div>
                  </div>
                </li>
              );
            })}
            {Object.keys(speedCuesCount).map((cue) => {
              return (
                <li key={`call-cue-${cue}`}>
                  <div className={styles.cueContainer}>
                    <div className={styles.cueName}>{cue}</div>
                    <div className={styles.cueCount}>{speedCuesCount[cue]}</div>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};
